import classcat from "classcat";
import React, { SyntheticEvent } from "react";
import { useTranslation } from "react-i18next";

import { IconTickCircle } from "@touchtech/web-baselayer-ui";

import {
  DELIVERY_OPTIONS_LABELS,
  DeliveryOptions,
  TranslationContext,
} from "@is/constants";

import css from "./DeliveryOptionsSwitcher.module.css";

type Props = {
  deliveryOptions: string[];
  activeDeliveryOption: string;
  onToggleDeliveryOptions: (event: SyntheticEvent) => void;
};

const DeliveryOptionsSwitcher = ({
  deliveryOptions,
  onToggleDeliveryOptions,
  activeDeliveryOption,
}: Props) => {
  const { t } = useTranslation(TranslationContext.Checkout);

  return (
    <div className={css.toggleContainer}>
      <div className={css.toggle}>
        <div
          className={classcat([
            css.toggleSlidingBackground,
            {
              [css.toggleTranslate]:
                activeDeliveryOption === DeliveryOptions.InstorePickup,
            },
          ])}
        ></div>
        {deliveryOptions.map((option) => (
          <button
            key={option}
            id={option}
            className={classcat([
              css.toggleOption,
              {
                [css.activeToggleOption]: option === activeDeliveryOption,
              },
            ])}
            onClick={onToggleDeliveryOptions}
          >
            {option === activeDeliveryOption && (
              <div className={css.tickIconContainer}>
                <IconTickCircle />
              </div>
            )}
            {t(DELIVERY_OPTIONS_LABELS[option])}
          </button>
        ))}
      </div>
    </div>
  );
};

export default DeliveryOptionsSwitcher;
